/*
 * @Author       : dengjianjun
 * @Date         : 2021-10-21 19:15:00
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2022-01-04 16:19:42
 * @Description  :
 * @FilePath     : /es-template/src/store/modules/train/getter.js
 */

export default {
  /**
   * @description: 当前差旅
   * @param {*} state
   * @return {Array}
   */
  travelInfo (state) {
    const {currentTravel} = state
    return currentTravel
  },
  
  /**
   * @description: 限制差旅城市列表
   * @param {*} state
   * @return {Array}
   */
  cityList(state,getters){
    return getters.travelInfo?.end_city_list ?? []
  },

  /**
   * @description: 酒店详情图片数组
   * @return {Array}
   */
  photos(state){
    return state.train?.train_photo_url
  },
  
  /**
   * @description: 制度id
   * @return {Number}
   */
  institution_id(state,getters){
    return getters.travelInfo?.institution_id
  },
  

  
  selectCityList(state, getters) {
    const {currentFromCity, currentToCity} = state;
    return [currentFromCity, currentToCity]
  },
  
  /**
   * @description: 乘车时间
   */  
  selectDate(state) {
    // 这个乘车时间存到getter里，之后如果有隐私，乘车时间一并在这里处理 travelType： 0 因公
    if (state.travelType == 0) {
      return state.selectDate
    }
  },
  
  /**
   * @description: 是否有差旅单或制度
   */
  hasTravel(state) {
    const {travelList, travel: {institution_list}} = state
    return travelList?.length > 0 || institution_list?.length > 0
  },
}
